var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"toggleable":"lg","type":"dark","variant":"primary"}},[_c('b-link',{attrs:{"href":_vm.href}},[_c('img',{staticClass:"mx-2",attrs:{"src":require("@/assets/logo.png"),"alt":"Logo"}}),_c('b-navbar-brand',[_vm._v(_vm._s(_vm.title))])],1),_c('user-profile'),_c('shopping-cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }